"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mantineSizeMap = exports.FieldSize = exports.IconDirection = exports.IconSize = void 0;
var IconSize;
(function (IconSize) {
    IconSize["LARGE"] = "48px";
    IconSize["NORMAL"] = "24px";
    IconSize["SMALL"] = "16px";
})(IconSize = exports.IconSize || (exports.IconSize = {}));
var IconDirection;
(function (IconDirection) {
    IconDirection["LEFT"] = "LEFT";
    IconDirection["UP"] = "UP";
    IconDirection["RIGHT"] = "RIGHT";
    IconDirection["DOWN"] = "DOWN";
})(IconDirection = exports.IconDirection || (exports.IconDirection = {}));
var FieldSize;
(function (FieldSize) {
    FieldSize["SMALL"] = "small";
    FieldSize["MEDIUM"] = "medium";
    FieldSize["LARGE"] = "large";
})(FieldSize = exports.FieldSize || (exports.FieldSize = {}));
/** Maps Tractable's design spec to Mantine's size input */
exports.mantineSizeMap = new Map([
    [FieldSize.SMALL, 'xs'],
    [FieldSize.MEDIUM, 'sm'],
    [FieldSize.LARGE, 'md'],
]);
